export default "__VITE_ASSET__KLrH_NLy__"